module.exports = __webpack_public_path__ + "img/security-item-06.6bbc3997.svg";